<app-dialog-heading [heading]="heading"></app-dialog-heading>

<div class="dialog-content" style="max-height: 70vh; overflow-y: auto; padding: 10px">
  <form [formGroup]="limitFormGroup">

    <mat-grid-list cols="1" rowHeight="75px">
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Limit Name</mat-label>
          <input matInput type="text" formControlName="name" required>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Limit Name')">help_outline</mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Limit Type</mat-label>
          <mat-select formControlName="limitType" required>
            <mat-option *ngFor="let type of limitTypeLookupValues" [value]="type.value">
              {{type.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Limit Type')">help_outline</mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Measure</mat-label>
          <mat-select formControlName="measure" required>
            <mat-option *ngFor="let measure of measureLookupValues" [value]="measure.value">
              {{measure.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Measure')">help_outline</mat-icon>
      </mat-grid-tile>


      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Accumulate By</mat-label>
          <mat-select formControlName="accumulateBy" required>
            <mat-option *ngFor="let accumulateBy of accumulateByLookupValues" [value]="accumulateBy.value">
              {{accumulateBy.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Accumulate By')">help_outline</mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Accumulate At</mat-label>
          <mat-select formControlName="accumulateAt" required>
            <mat-option *ngFor="let accumulateAt of accumulateAtLookupValues" [value]="accumulateAt.value">
              {{accumulateAt.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Accumulate At')">help_outline</mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <mat-form-field>
          <mat-label>Value</mat-label>
          <input matInput type="number" formControlName="value" required>
        </mat-form-field>
        <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Value')">help_outline</mat-icon>
      </mat-grid-tile>

      <mat-grid-tile>
        <greydom-date-picker
          label="Start Date"
          formControlName="startDate"
          [required]="true"
          [tooltip]="getInfoTooltip('Start Date')"
          [maxDate]="limitFormGroup.get('endDate').value">
        </greydom-date-picker>
      </mat-grid-tile>

      <mat-grid-tile>
        <greydom-date-picker
          label="End Date"
          formControlName="endDate"
          [tooltip]="getInfoTooltip('End Date')"
          [minDate]="limitFormGroup.get('startDate').value">
        </greydom-date-picker>
      </mat-grid-tile>

    </mat-grid-list>
  </form>
  <p style="color: red">{{errorMessage}}</p>
</div>

<mat-dialog-actions align="center">
  <button mat-raised-button [mat-dialog-close]="false" color="warn">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!limitFormGroup.valid" (click)="onSaveLimit()">
    Save
  </button>
</mat-dialog-actions>
